import RequestAbstract from "../abstract";

export default class PublicChargebackComments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-chargeback-comments';
    }
}
